export default __webpack_public_path__ + "static/media/about.1c849d79.svg";